import React from "react";

const OnBlur = (props) => {
    return React.cloneElement(props?.children, {onBlur: () => {props?.inputTouched?.()}})
}

export default OnBlur